import { render, staticRenderFns } from "./RegisterKompack.vue?vue&type=template&id=0a9d7d00&"
import script from "./RegisterKompack.vue?vue&type=script&lang=js&"
export * from "./RegisterKompack.vue?vue&type=script&lang=js&"
import style0 from "./RegisterKompack.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports